import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
  breadcumb: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
    changeBreadcumb: (state, action) => {
      state.breadcumb = action.payload;
    },
  },
});

export const {login, logout, changeBreadcumb} = authSlice.actions;

export default authSlice.reducer;
